import { Link } from "@tanstack/react-router";

export const ShowAll = () => {
  return (
    <Link
      to="/"
      title="Show all coffee checkins"
      style={{
        display: "inline-block",
        fontSize: "12px",
        fontStyle: "italic",
        fontWeight: 300,
      }}
    >
      show all checkins
    </Link>
  );
};
